/**
 * Created by M.J. van der Werf <vanderwerf@bluehorizon.nl> on 15-8-18.
 */
import React from "react";
import LoggedOff from "../../../../../component/Main/Base/LoggedOff/LoggedOff";
import {Card, CardContent, Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography/Typography";
import BigCardHeader from "../../../../../component/Card/BigCardHeader";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = theme => ({
    typography: {
        marginBottom: "10px"
    },
});

const ThanksForSignature =
    ({classes}) =>
        <LoggedOff header="Bedankt voor de ondertekening">
            <Grid item
                  lg={12}
                  md={12}>
                <Card>
                    <CardContent>
                        <BigCardHeader title="Bedankt voor uw ondertekening"/>
                        <Typography className={classes.typography}
                                    variant="body1">
                            Bedankt voor de ondertekening, wij zullen deze zo spoedig mogelijk verwerken.
                        </Typography>

                        <Typography className={classes.typography}
                                    variant="body1">
                            Hartelijke groet namens het team van Bankgarantie.com
                        </Typography>
                    </CardContent>
                </Card>

            </Grid>
        </LoggedOff>

export default withStyles(styles)(ThanksForSignature);
